import { IAddress } from '../../indigofair/data/IAddress';

export namespace IMatchedBusiness {
  export type TypeType = 'MANUAL' | 'GOOGLE_PLACES' | 'YELP' | 'FACEBOOK';

  export enum Type {
    MANUAL = 'MANUAL',
    GOOGLE_PLACES = 'GOOGLE_PLACES',
    YELP = 'YELP',
    FACEBOOK = 'FACEBOOK',
  }

  /**
   * Return an instance of IMatchedBusiness with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IMatchedBusiness>
  ): IMatchedBusiness =>
    ({
      google_place_types: [],
      ...(partial ?? {}),
    }) as IMatchedBusiness;
}

/**
 * Returned by the Server when searching for businesses
 */
export interface IMatchedBusiness {
  id: string | undefined;
  type: keyof typeof IMatchedBusiness.Type | undefined;
  name: string | undefined;
  location: string | undefined;
  state: string | undefined;
  google_place_types: Array<string>;
  address: IAddress | undefined;
  website_url: string | undefined;
}
